/**
 * Base Icon Component
 * Provides a reusable SVG icon wrapper with consistent sizing and styling
 */

import React from 'react';

interface IconProps {
  size?: number | string;
  className?: string;
  color?: string;
  style?: React.CSSProperties;
  title?: string;
  children: React.ReactNode;
}

export const Icon: React.FC<IconProps> = ({
  size = 16,
  className = '',
  color = 'currentColor',
  style = {},
  title,
  children
}) => {
  const sizeValue = typeof size === 'number' ? `${size}px` : size;

  return (
    <svg
      width={sizeValue}
      height={sizeValue}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`icon ${className}`}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        ...style
      } as React.CSSProperties}
      {...(title && { title, 'aria-label': title } as any)}
    >
      {children}
    </svg>
  );
};

export default Icon;
